import gql from 'graphql-tag';

export const UpdateAdminAnnouncementBannerMutation = gql`
	mutation UpdateAdminAnnouncementBannerMutation(
		$announcementBanner: ConfluenceUpdateAdminAnnouncementBannerInput!
	) {
		updateAdminAnnouncementBanner(announcementBanner: $announcementBanner) {
			adminAnnouncementBannerSetting {
				appearance
				content
				id
				isDismissible
				status
				title
				visibility
				scheduledEndTime
				scheduledStartTime
				scheduledTimeZone
			}
			errors {
				message
				extensions {
					errorType
					... on AdminAnnouncementBannerMutationErrorExtension {
						adminAnnouncementBannerList {
							id
							title
							scheduledStartTime
							scheduledEndTime
						}
					}
				}
			}
			success
		}
	}
`;
